import OrderHistory from "@/components/business/orders/OrderHistory";

const UserPaymentsPage = () => {
    return (
        <div>
            <h1>User Payments</h1>
            <OrderHistory />
        </div>
    );

};



export default UserPaymentsPage;